var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "TmFooter",
    [
      _c(
        "TmRow",
        [
          _c(
            "TmCol",
            { attrs: { md: "4" } },
            [
              _c("TmFooterLinks", [
                _c(
                  "a",
                  {
                    attrs: {
                      slot: "title",
                      href: _vm.getDomain() + "/co-nejvic-chcete",
                      target: "_blank"
                    },
                    slot: "title"
                  },
                  [_vm._v("Co nejvíc chcete")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/dulezite/volani",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Volání")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/telefony",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Telefony")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/dulezite/internet",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Internet")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/t-mobile-tv",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Televize")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/sms/open.jsp",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Poslat SMS")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/mms-vyzvednuti-na-webu",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Vyzvednout MMS")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "TmCol",
            { attrs: { md: "4" } },
            [
              _c("TmFooterLinks", [
                _c(
                  "a",
                  {
                    attrs: {
                      slot: "title",
                      href: _vm.getDomain() + "/co-portebujete",
                      target: "_blank"
                    },
                    slot: "title"
                  },
                  [_vm._v("Co potřebujete")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/kariera-hledame",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Kariéra v T-Mobile")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/kontakty-t-mobile",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Kontakty & prodejny")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  { attrs: { href: "http://t-press.cz/", target: "_blank" } },
                  [_vm._v("Pro média")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/microsites/pomahame/index.html",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Pomáháme")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/dulezite/katalog-sluzeb",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Katalog služeb")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/ochrana-udaju",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Ochrana soukromí")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://www.t-mobile.cz/ochrana-udaju/zpracovani-cookies",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Zásady zpracování cookies")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "TmCol",
            { attrs: { md: "4" } },
            [
              _c("TmFooterLinks", [
                _c(
                  "a",
                  {
                    attrs: {
                      slot: "title",
                      href: _vm.getDomain() + "/podpora/caste-dotazy",
                      target: "_blank"
                    },
                    slot: "title"
                  },
                  [_vm._v("Co se může hodit")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/dulezite/podpora",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Podpora")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/presmerovani/vyhody-nakupu",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Výhody eShopu")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/mapapokryti",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Mapa pokrytí")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/aplikace-muj-t-mobile",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Aplikace Můj T-Mobile")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/podpora/ke-stazeni",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Podmínky a dokumenty")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getDomain() + "/podpora/vyuctovani-a-platby",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Vyúčtování a platby")]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "social" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.facebook.com/TMCZbusiness/",
              target: "_blank"
            }
          },
          [_c("TmIcon", { attrs: { type: "facebook", size: "sm" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.instagram.com/tmobile_cze/",
              target: "_blank"
            }
          },
          [
            _c("TmIcon", {
              attrs: { type: "instagram", size: "sm", width: "25" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "http://www.youtube.com/user/tmobilecz",
              target: "_blank"
            }
          },
          [
            _c("TmIcon", {
              attrs: { type: "youtube", size: "sm", width: "25" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "https://twitter.com/TMobile_CZE", target: "_blank" }
          },
          [
            _c(
              "svg",
              { attrs: { viewBox: "0 0 25 25", width: "20", height: "20" } },
              [
                _c("path", {
                  attrs: {
                    fill: "currentColor",
                    d:
                      "M12.12,10.96l-3.3-4.62h-1.76l4.09,5.73,.51,.72h0l3.5,4.9h1.76l-4.29-6.01-.51-.72ZM23.62,1.38c-.92-.92-2.02-1.38-3.31-1.38H4.69C3.4,0,2.29,.46,1.38,1.38,.46,2.29,0,3.4,0,4.69v15.62c0,1.29,.46,2.4,1.38,3.31s2.02,1.38,3.31,1.38h15.62c1.29,0,2.4-.46,3.31-1.38s1.38-2.02,1.38-3.31V4.69c0-1.29-.46-2.4-1.38-3.31ZM14.63,18.51l-3.55-5.06-4.43,5.06h-1.15l5.08-5.78L5.5,5.49h3.87l3.35,4.78,4.2-4.78h1.15l-4.84,5.51,5.27,7.5h-3.87Z"
                  }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "http://www.charger.cz/", target: "_blank" } },
          [
            _c("TmIcon", {
              attrs: { type: "charger", size: "sm", width: "25" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "copyright" }, [
        _vm._v(
          "© 2004-" +
            _vm._s(new Date().getFullYear()) +
            " T-Mobile Czech Republic a.s."
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "disclaimer" }, [
        _vm._v(
          "Podle zákona o evidenci tržeb je prodávající povinen vystavit kupujícímu účtenku. Zároveň je povinen zaevidovat přijatou tržbu u správce daně on-line; v případě technického výpadku pak nejpozději do 48 hodin."
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }